export default __webpack_public_path__ + "static/media/Facebook_white.b000fb16.svg";